var map = {
	"./182.png": 2805,
	"./360.png": 1263,
	"./360智脑.png": 9176,
	"./Snipaste_2023-10-24_15-08-38.png": 7268,
	"./Snipaste_2023-10-24_15-45-04.png": 950,
	"./banner.png": 758,
	"./close.png": 3474,
	"./collect.png": 4456,
	"./collectT.png": 7902,
	"./copy_n.png": 5612,
	"./eye.png": 3893,
	"./logo/bacee74f3c1bb7758b15885a8d2b1bae.jpg": 2476,
	"./logo/文心一言.png": 7864,
	"./logo/智谱.png": 2269,
	"./logo/讯飞星火.png": 2767,
	"./logo/通义千问.png": 9438,
	"./logo/默认头像.png": 5913,
	"./logod.png": 5213,
	"./new.png": 7288,
	"./pen.png": 2611,
	"./product-card-1.png": 3042,
	"./product-card-2.png": 3753,
	"./product-card-3.png": 2576,
	"./quesheng.png": 802,
	"./register_1.png": 1495,
	"./register_2.png": 812,
	"./register_3.png": 2437,
	"./remove.png": 7180,
	"./remove1.png": 8511,
	"./search.png": 9432,
	"./time.png": 9623,
	"./u16.png": 9158,
	"./u21.png": 9068,
	"./u25.png": 3960,
	"./u30.png": 4618,
	"./u41.png": 7150,
	"./u42.png": 8949,
	"./u43.png": 9532,
	"./u61.png": 3096,
	"./u62.png": 8851,
	"./u63.png": 3642,
	"./u66.png": 2087,
	"./u67.png": 6510,
	"./u99.png": 6409,
	"./停止回答.png": 960,
	"./删除.png": 6912,
	"./商汤日日新.png": 6418,
	"./商量.png": 4949,
	"./天工.png": 8634,
	"./文心一言.png": 638,
	"./昆仑万维天工.png": 7488,
	"./智谱.png": 8927,
	"./月之暗面.png": 6384,
	"./混元.png": 6,
	"./登录.png": 3916,
	"./百川.png": 2831,
	"./百度.png": 6844,
	"./稀宇科技.png": 5872,
	"./讯飞星火.png": 7309,
	"./豆包.png": 8655,
	"./通义千问.png": 6328,
	"./魔搭.png": 4525
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1382;